define(
    'models/admin_note.model',[
        'loader',
        'config',
        'helper',
        'sandbox'
    ],
    function (
        Loader,
        Config,
        Helper,
        Sandbox
        )
    {
        var _ = Loader._;

        var AdminNoteModel = Loader.Backbone.Model.extend({

            defaults: {
                text: null,
                state: null,
                lastModifierId: null,
                lastModifierLogin: null,
                lastModificationTime: null,
                canModify: null
            },

            initialize: function()
            {
                var _this = this;
                this.model = this.get('model');
            },

            getNote: function(callback)
            {
                var _this = this;
                Sandbox.transport.send(Config.transport.channels.getAdminNotes, {"board_id": this.model.get('forum').get('boardId')},
                    function(result){
                        _this.set('text', result.text);
                        _this.set('state', result.state);
                        _this.set('lastModifierId', result.last_modifier_id);
                        _this.set('lastModifierLogin', result.last_modifier_login);
                        _this.set('lastModificationTime', result.last_modification_time);
                        _this.set('canModify', result.can_modify);
                        _.isFunction(callback) && callback(result);
                    },
                    function(err){}
                );
            },

            saveNote: function(params, callback)
            {
                var _this = this;
                Sandbox.transport.send(Config.transport.channels.setAdminNotes, {
                        "board_id": this.model.get('forum').get('boardId'),
                        "user_id": this.model.get('users').getMe().get('id'),
                        "note_text": params.text,
                        "note_state": params.state,
                        "note_can_modify": params.canModify
                    },
                    function(result){
                        _this.set('text', params.text);
                        _.isFunction(callback) && callback(result);
                    },
                    function(err){},
                    true
                );
            }

        });

        return {
            initialize: function(model)
            {
                return new AdminNoteModel({
                    model: model
                })
            }
        }
    }
);

